import { AfterViewInit, Component, inject, Input } from '@angular/core';
import { GalleryService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { IUser } from 'src/app/shared/models';

@Component({
  selector: 'app-story-docs',
  templateUrl: './story-docs.component.html',
  styleUrls: ['./story-docs.component.scss']
})
export class StoryDocsComponent implements AfterViewInit {

  @Input() public gallery: any[];
  @Input() public isMobile;
  @Input() public slidesPerView = 6.5;
  breakpoints = {
    600: { perView: 3.5 },
    992: { perView: 6.5, focusAt: 0 }
  };

  public vwo = inject(VwoService);
  public vars = inject(VariablesService);
  openLoginPopup = false;

  userData: IUser;

  constructor(
    private galleryService: GalleryService
  ) { }

   ngOnInit() {
    this.vars.userData.subscribe(val => this.userData = val);
   }
   signinClosed() {
    this.openLoginPopup = false;
   }

  ngAfterViewInit() {
    // this.galleryService.initGallery('lightgalleryStoryDocs');
  }
}
